import { ItemSelect } from './api/types';

interface Entity {
  [key: string]: any;
}

export function mapEntityAttributes<T extends Entity>(items: T[], attributeText: keyof T, attributeValue: keyof T): { text: string; value: any }[] {
  return items.map((item) => ({
    text: item[attributeText],
    value: item[attributeValue]
  }));
}

export function mapAttributes(items: { [key: string]: string }): ItemSelect[] {
  return Object.entries(items).map(([text, value]) => ({
    text,
    value
  }));
}

export function getErreurAvecMessage(error: any): error is { data: { message: string } } {
  return error.response?.data?.error || 'Une erreur est survenue';
}
